export const SIZE_25 = '25%';
export const SIZE_33 = '33%';
export const SIZE_50 = '50%';
export const SIZE_75 = '75%';
export const SIZE_FULL = '100%';

export type SizeType =
    | typeof SIZE_25
    | typeof SIZE_33
    | typeof SIZE_50
    | typeof SIZE_75
    | typeof SIZE_FULL;

export const SIZES = [SIZE_25, SIZE_33, SIZE_50, SIZE_75, SIZE_FULL] as const;

/**
 * Priority map for comparing sizes (higher number = larger size)
 */
export const SIZE_PRIORITY: Record<SizeType, number> = {
    [SIZE_25]: 1,
    [SIZE_33]: 2,
    [SIZE_50]: 3,
    [SIZE_75]: 4,
    [SIZE_FULL]: 5
} as const;
